import React, { FC } from 'react';
import {
	Box,
	Button,
	Heading
	// Link, Text
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Yup } from '../../Utils/Yup';
import { ReactFormInput } from '../../Components/Inputs/ReactFormInput';
import Icons from '../../Components/Icons/icons';
import { useTranslation } from 'react-i18next';
import { i18n } from '../../Translation/Translation';
// import { Link as RouteLink } from 'react-router-dom';
// import { pages } from '../../Constants/Pages';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { CustomerApi } from '../../API/sdk';

interface IForm {
	oldPassword: string;
	newPassword: string;
	newPasswordRepeact: string;
}

const schema = Yup.object<IForm>().shape({
	oldPassword: Yup.string().required(i18n.t('common:VALIDATION_REQUIRED')),
	newPassword: Yup.string().required(i18n.t('common:VALIDATION_REQUIRED')),
	newPasswordRepeact: Yup.string()
		.required(i18n.t('common:VALIDATION_REQUIRED'))
		.test('newPassword', i18n.t('common:VALIDATION_MUST_MATCH_PASSWORD'), function (value) {
			console.log({ parent: this.parent, value });

			return this.parent.newPassword === value;
		})
});

interface MokkiProductFormProps {
	onSubmit: (x: IForm) => void;
}

const defaultValues: IForm = {
	oldPassword: '',
	newPassword: '',
	newPasswordRepeact: ''
};

export const ChangePassword = () => {
	const handleSubmit = async (form: IForm) => {
		const result = await CustomerApi.saveNewPassword({
			oldPassword: form.oldPassword,
			newPassword: form.newPassword
		});
		if (result.data) {
			alert('OK');
		} else {
			alert('FAIL');
		}
	};

	return <ChangePasswordForm onSubmit={handleSubmit} />;
};

export const ChangePasswordForm: FC<MokkiProductFormProps> = (props) => {
	const form = useForm<IForm>({
		resolver: yupResolver(schema),
		defaultValues
	});
	const [t] = useTranslation(['calendar', 'common']);

	return (
		<Box pr={2}>
			<form onSubmit={form.handleSubmit(props.onSubmit)}>
				<Heading as="h3" fontSize="lg" my={4}>
					{t('CHANGE_PASSWORD_PAGE_TITLE')}:
				</Heading>
				{/* <Link as={RouteLink} to={pages.services}>
					<Text ml={3} as="span">
						<FontAwesomeIcon icon={faArrowLeft} />
						{t('common:RETURN_BTN_LABEL')}
					</Text>
				</Link> */}

				<ReactFormInput
					formProp={form}
					label={t('OLD_PASSWORD_LABEL')}
					name="oldPassword"
					maxW="28rem"
				/>
				<ReactFormInput
					formProp={form}
					label={t('NEW_PASSWORD_LABEL')}
					name="newPassword"
					maxW="28rem"
				/>
				<ReactFormInput
					formProp={form}
					label={t('NEW_PASSWORD_REPEAT_LABEL')}
					name="newPasswordRepeact"
					maxW="28rem"
				/>

				<Button mt={3} type="submit" variant="solid" leftIcon={Icons.save}>
					{t('SUBMIT_CHANGE_PASSWORD')}
				</Button>
			</form>
		</Box>
	);
};
